import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.45 1.403A2 2 0 0 1 18 3.326V5h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a1 1 0 0 1-1-1V6.754a2 2 0 0 1 1.45-1.923zM18 7v1h2V7zm2 3h-2v5.246a2 2 0 0 1-1.45 1.923L10.14 19H20zM4 18.674V6.754l12-3.428v11.92zM13 8a1 1 0 0 1 1 1v.05a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }